import { useTranslation } from "react-i18next";

import { getAnimation } from "./screensaver/Screensaver";
import valora from "../../assets/valora.svg";
import { Tenant } from "../types/Config";

export const Initializing = ({ tenant }: { tenant: Tenant | null }) => {
    const { t } = useTranslation();

    const genericLoadingPage = (
        <div className="flex h-full flex-col items-center bg-indigo-950">
            <img src={valora} alt="valora" className="mt-5" />
            <div className="grid grow place-items-center text-2xl text-white">
                {t("pleaseWait")}
            </div>
        </div>
    );

    return tenant ? getAnimation(tenant) : genericLoadingPage;
};
